/** @prettier */
import React, { useRef, useLayoutEffect, memo } from "react";
import { assert } from "./assert";
import ChartJs from "chart.js";

// Re-export for convenience
export type ChartConfiguration = ChartJs.ChartConfiguration;

type ChartProps = {
    config: ChartConfiguration;
};
/**
 * Wrapper around chartJS: takes the configuration as an input
 * and builds and mounts the chart
 */
export const Chart = memo(({ config }: ChartProps) => {
    const canvasRef = useRef<HTMLCanvasElement>(null);

    useLayoutEffect(() => {
        assert(canvasRef.current, "Expected ref");
        const chart = new ChartJs(canvasRef.current, config);
        return () => {
            chart.destroy();
        };
    }, [config]);

    return <canvas ref={canvasRef} />;
});
